/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsDisplaysService
 */
import * as References from './BusinessUnitsDisplaysService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsDisplaysService#getBusinessUnitDisplaysForUser
 */
export const GET_BUSINESS_UNIT_DISPLAYS_FOR_USER_QUERY_FIELD_NAME = 'com_hubspot_business_units_rpc_BusinessUnitsDisplaysService_getBusinessUnitDisplaysForUser';
export const GET_BUSINESS_UNIT_DISPLAYS_FOR_USER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BUSINESS_UNIT_DISPLAYS_FOR_USER_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getBusinessUnitDisplaysForUserRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsDisplaysService#getBusinessUnitDisplaysForUserByNames
 */
export const GET_BUSINESS_UNIT_DISPLAYS_FOR_USER_BY_NAMES_QUERY_FIELD_NAME = 'com_hubspot_business_units_rpc_BusinessUnitsDisplaysService_getBusinessUnitDisplaysForUserByNames';
export const GET_BUSINESS_UNIT_DISPLAYS_FOR_USER_BY_NAMES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BUSINESS_UNIT_DISPLAYS_FOR_USER_BY_NAMES_QUERY_FIELD_NAME,
  args: ['names'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getBusinessUnitDisplaysForUserByNamesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});